module.exports = __webpack_public_path__ + "media/images/flags/4x3/lca-57a1f4149290988cd8e7315fea97af1f.svg";